import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changeFooter}  from '../../../Structure/actions/actionsStructure';
import WhatIs from '../../../Shared/components/Info/WhatIs';
import Why from '../../../Shared/components/Info/Why';
import Who from '../../../Shared/components/Info/Who';
import SocialMedia from '../../../Shared/components/Contact/SocialMedia';
import {Link, browserHistory} from 'react-router';
import {PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO} from "../../../../App/RouterAdopta";

class Footer extends Component {

    constructor(props) {
        super(props);

        this.configInformation = {
            socials: [
                {
                    url: 'https://www.facebook.com/adoptaunanimal.es/',
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: 'https://www.instagram.com/adoptaunanimal.es/',
                    socialIcon: "lab la-instagram"
                }
            ]

        };

        this.showHide = this.showHide.bind(this);
    }

    showHide() {
        if (!this.props.showFooter) {
            this.props.changeFooter(true);
        }
    }

    goToSignup() {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO);
    }

    render() {
        let classFooter = "footer-default";
        // if (this.props.percent === 90) {
        //     classFooter += " footer-default-90";
        // } else if (this.props.percent === 100) {
        //     classFooter += " footer-default-100";
        // }
        return (
            <div className={classFooter + " "}>
                <hr/>
                <div className="container">
                    {this.props.configFooter.moreInfo &&
                    <div>
                        <WhatIs/>
                        <hr className="separator-simple"/>
                        <Why/>
                        <hr className="separator-simple"/>
                        <Who/>
                        <hr className="separator-double"/>
                    </div>
                    }
                    <div className="row">
                        {!this.props.access.isLogin &&
                        <div className="col-lg-6">
                            <h6 className="footer-default__heading">¿Eres una asociación?</h6>
                            <p>
                                Si eres una protectora o asociación de animales y quieres utilizar la plataforma de
                                Adopta un Animal, no tienes más que contactar
                                con nosotros o registrarte y empezar a disfrutar de todas las ventajas que Adopta un
                                animal te ofrece.
                            </p>

                            <a href={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO+"?utm_source=buscador&utm_medium=footer"}
                               className="btn btn-outline-secondary btn-get-started">Vamos!</a>
                            <hr/>
                        </div>

                        }
                        <div className="col-lg-4 col-md-4">
                            <h6 className="footer-default__heading footer-default__heading--sm"></h6>
                        <br/>
                            <ul className="legal list-unstyled">
                                <li>
                                    <a href='https://blog.adopta-un-animal.es/preguntas-frecuentes/?utm_source=buscador&utm_medium=footer'
                                       target='_blank' rel="nofollow">Preguntas Frecuentes</a>
                                </li>
                                <li>
                                    <a href='https://blog.adopta-un-animal.es/politica-de-cookies/?utm_source=buscador&utm_medium=footer'
                                       target='_blank' rel="nofollow">Politica de cookies</a>
                                </li>
                                <li>
                                    <a href='https://blog.adopta-un-animal.es/politica-privacidad/?utm_source=buscador&utm_medium=footer'
                                       target='_blank' rel="nofollow">Politica de privacidad</a>
                                </li>
                                <li>
                                    <a href='https://blog.adopta-un-animal.es/aviso-legal/?utm_source=buscador&utm_medium=footer'
                                       target='_blank' rel="nofollow">Aviso legal</a>
                                </li>
                                <li>
                                    <a href='https://tienda.adopta-un-animal.es/pages/quienes-somos?utm_source=buscador&utm_medium=footer'
                                       target='_blank' rel="nofollow">Quiénes somos</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <div className="row rrss_copyright">
                        <div className="col-lg-8">
                            <span className="footer-default__copyright">© Adopta un Animal 2023</span>
                        </div>
                        <div className="col-lg-4">
                            <div className="footer-default__follow-us">
                                <span className="footer-default__follow-us-text">Síguenos:</span>
                                <div className="footer-default__follow-us-items">
                                     <SocialMedia
                                        configInformation = {this.configInformation}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        $(window).on('scroll', function() {
            if ($(window).scrollTop() + $(window).height() > $('.index-resume').outerHeight() + 70) {
                // $('body').addClass('tight');
                // $('.mouse_scroll').addClass("animated-0s fadeOut");
                $('.mouse_scroll').hide();

                // $('.buttonToTop').removeClass("animated fadeOutRight").addClass("animated fadeInRight");
                $('.buttonToTop').show();
            } else {
                // $('body').removeClass('tight');
                // $('.mouse_scroll').removeClass("animated-0s fadeOut").addClass("animated-0s fadeIn");
                $('.mouse_scroll').show();
                $('.buttonToTop').hide();
                // $('.buttonToTop').removeClass("animated fadeInRight").addClass("animated fadeOutRight");
                // $('.buttonToTop').removeClass("animated fadeInRight").addClass("animated fadeOutRight");
            }
        });

        //BACK TO PRESENTATION MODE
        $("html").on("click", "body.tight .index-resume", function() {
                //console.log("Haciendo scrollTop");
                $('html, body').animate({
                    scrollTop:$('.index-resume').outerHeight() - $(window).height()
                }, 500);
        });

        //Click mouseIcon
        let element = $(".footer-default");
        if (element.length !== 0) {
            $('.mouse_scroll').on("click", function() {
                //console.log("Haciendo scrollTop");
                $('body,html').stop(true,true).animate({
                    scrollTop: element.offset().top
                },700);
            });
        }
    }

}

function mapStateToProps(state) {
    return {
        access: state.access,
        showFooter: state.structureControl.showFooter
    }

}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {changeFooter})(Footer)
